import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import EuropeaLogo from "./EuropeaLogo";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLocale } from "./i18n/locale";

export interface OnboardingHeaderProps {
  /** Step 1 is the entry point of the journey, so it has nothing to go back to. */
  showBack?: boolean;
  /** "light" inverts the lockup and controls for the dark hero on step 1. */
  variant?: "light" | "dark";
  className?: string;
}

const OnboardingHeader: FC<OnboardingHeaderProps> = ({
  showBack = true,
  variant = "dark",
  className = "",
}) => {
  const navigate = useNavigate();
  const { t } = useLocale();

  return (
    <header className={`flex items-center justify-between ${className}`}>
      {showBack ? (
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label={t.common.back}
          className={`-ml-2 flex h-10 w-10 items-center justify-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-6000 ${
            variant === "light"
              ? "text-white hover:bg-white/15"
              : "text-neutral-700 hover:bg-white/70"
          }`}
        >
          <svg
            className="h-5 w-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.8}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M19 12H5m0 0l7 7m-7-7l7-7" />
          </svg>
        </button>
      ) : (
          // <span className="h-10 w-10" aria-hidden="true" />
          ""
      )}

      <EuropeaLogo variant={variant} className="h-9 text-[15px]" />

      <LanguageSwitcher variant={variant} />
    </header>
  );
};

export default OnboardingHeader;
